import PropertyItem from 'Components/Personal/Property/PropertyItem'
import { useContactMetadata } from 'Modules/ContactModule'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Col, ListGroup } from 'reactstrap'

export default function PropertiesList({ profile, groupIndex }) {
  const { t } = useTranslation();
  const profileData = useContactMetadata(profile.properties)
  const groupData = profileData[groupIndex]
  console.log('PropertiesList profileData object: ', profileData)
  console.log('PropertiesList raw properties: ', profile.properties)
  console.log('PropertiesList groupIndex', groupIndex)
  console.log('PropertiesList groupData', groupData)
  if (!groupData) return null

  return (

    <Col style={{ border: '1px solid green' }}>
      <div>
        <h4>{t(groupData.showName)}</h4>
        <p>{t(groupData.description)}</p>
        <ListGroup>
          {Object.entries(groupData.properties).map(([key, property], index) => {
            // Ensure key is never empty string - handle null, undefined, empty string, or whitespace-only
            const safeKey = (key && typeof key === 'string' && key.trim() !== '') ? key : `property-${index}`
            return (
              <PropertyItem key={safeKey} property={{ ...property, name: key }} />
            )
          })}
        </ListGroup>
      </div>
    </Col>
  )
}
